import type { WidgetProps } from '@rjsf/utils';

import { KeyValue } from '@/components/ui/keyValue/keyValue';

export const CheckboxWidget = ({
  label,
  value,
  options,
  name
}: WidgetProps) => {
  const { enumOptions } = options;

  /**
   * @returns a pair {label, value}
   */
  const selectedOption = enumOptions?.find(
    option => option.value === value
  ) || {
    label: value
  };

  return (
    <KeyValue dataCyName={name} title={label}>
      {selectedOption.label && <span>{selectedOption.label}</span>}
    </KeyValue>
  );
};
